import type { ComputedRef, MaybeRefOrGetter } from 'vue'
import { computed, toValue } from 'vue'

import type { TableVariants } from './constants'
import { tableVariants } from './constants'

export const useCellStyles = (
  variant: MaybeRefOrGetter<TableVariants>
): {
  classes: ComputedRef<string>
} => {
  const classes = computed(() => {
    const effectiveVariant = toValue(variant)

    return effectiveVariant === tableVariants.FLAT
      ? 'tw-px-4 tw-py-2 tw-border-sf-snow-dark tw-border tw-border-solid'
      : ''
  })

  return {
    classes,
  }
}
